import { FC, useCallback, useEffect } from 'react';
import { css } from '@emotion/react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { DropDownMultiFilterSelector } from '@frontend/analytics-shared';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../tracking-ids';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export const SentimentFilterTray: FC<{ disabled?: boolean; showClear?: boolean }> = ({
  disabled,
  showClear = true,
}) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  const isDisabled = disabled || isLoading;

  const onChange = useCallback(
    (value: string[]) => {
      updateFilterValues({ sentiments: value as CallIntelTypes.SentimentEnum[] });
    },
    [updateFilterValues]
  );

  useEffect(() => {
    updateFilterModified({ sentiments: !!filterValues.sentiments?.length });
  }, [filterValues.sentiments, updateFilterModified]);

  return (
    <FilterTraySection
      label={t('Customer Sentiment')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange([])}
    >
      <DropDownMultiFilterSelector
        css={styles.sentimentDropDown}
        label={t('Select Customer Sentiments')}
        onChange={onChange}
        options={getOptions('sentiment', 'array')}
        trackingId={trackingIds.callIntel.customerSentimentFilter}
        value={filterValues.sentiments}
      />
    </FilterTraySection>
  );
};

const styles = {
  sentimentDropDown: css`
    > div:last-of-type {
      max-height: none;
    }
  `,
};
